/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Industry type (must match OrganizationType enum)
 */
export type SocialRegisterBodyIndustry = typeof SocialRegisterBodyIndustry[keyof typeof SocialRegisterBodyIndustry];


export const SocialRegisterBodyIndustry = {
  IME: 'IME',
  LOGISTICS: 'LOGISTICS',
  LEGAL: 'LEGAL',
  FINANCE: 'FINANCE',
  HOSPITALITY: 'HOSPITALITY',
  ENERGY: 'ENERGY',
  COMPENSATION: 'COMPENSATION',
  CONSTRUCTIONS: 'CONSTRUCTIONS',
  ADVERTISING: 'ADVERTISING',
  MANUFACTURING: 'MANUFACTURING',
  ZONING: 'ZONING',
  HEALTHCARE: 'HEALTHCARE',
  ALLIED_HEALTH: 'ALLIED_HEALTH',
  CLINICAL_SPECIALISTS: 'CLINICAL_SPECIALISTS',
  LEGAL_HEALTH: 'LEGAL_HEALTH',
  UNDERWRITING: 'UNDERWRITING',
} as const;
